// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1EZVx","container":"styles_container__1W0Wz","title":"styles_title__3-GBM","wrapper":"styles_wrapper__3D8BZ","answer":"styles_answer__z_CDZ"};